import { getStaffShowByConfig } from '../utilFn';
export default getStaffShowByConfig;
